import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Responsive } from '~/components';
import { Mobile, Desktop } from './responsive';
import { columns } from './utils';
import EmptyPage from '~/pages/EmptyPage';
import {
  getSelectedMatchEventsRequest,
  getSelectedMatchDirectStatsRequest,
} from '~/store/modules/matches/actions';

export default function Direct() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    events: { data: events, failed: eventsFailed },
    selectedMatch: { data: selectedMatch },
    directStats: { data: directStats, loading, failed: directStatsFailed },
  } = useSelector(state => state.matches);
  const {
    data: { matchIsBeingPlayed },
  } = useSelector(state => state.matches.matchStatus);
  const [wasFetchedAtLeastOnce, setHasFetched] = useState(false);

  const hasError = !events || !selectedMatch || !directStats;

  useEffect(() => {
    const shouldFetch = matchIsBeingPlayed || matchIsBeingPlayed === null;
    const fetchEvents = () => {
      if (selectedMatch) {
        if (shouldFetch || !wasFetchedAtLeastOnce) {
          dispatch(getSelectedMatchEventsRequest(selectedMatch.id));
          dispatch(getSelectedMatchDirectStatsRequest(selectedMatch.id));
          setHasFetched(true);
        }
      }
    };
    fetchEvents();

    const interval = setInterval(fetchEvents, 60000);

    return () => {
      clearInterval(interval);
    };
  }, [dispatch, selectedMatch, matchIsBeingPlayed, wasFetchedAtLeastOnce]);

  const showEmptyState =
    hasError ||
    (!loading &&
      Object.keys(directStats).length < 1 &&
      eventsFailed &&
      directStatsFailed);

  if (showEmptyState) return <EmptyPage subtitle={t('emptySubtitleLive')} />;

  const directProps = {
    homeTeamShield: selectedMatch ? selectedMatch.homeTeam.shieldImageUrl : '',
    awayTeamShield: selectedMatch ? selectedMatch.awayTeam.shieldImageUrl : '',
    timelineData: events,
    columns: columns(directStats),
    title: t('clubStats'),
    directStats,
    homeTeam: selectedMatch ? selectedMatch.homeTeam : null,
    awayTeam: selectedMatch ? selectedMatch.awayTeam : null,
    eventsFailed,
    directStatsFailed,
  };

  return (
    <Responsive
      sm={<Mobile {...directProps} />}
      lg={<Desktop {...directProps} tabletMode />}
      xl={<Desktop {...directProps} />}
    />
  );
}
